import {useMediaQuery} from '@material-ui/core';
import {theme} from 'Core/components/WithTheme';
import React, {ReactNode} from 'react';

type EnrollmentFileProcessingStepProps = {
  stepName: string;
  titleClassName: string;
  showDividerLine?: boolean;
  statusIcon: JSX.Element;
  children: ReactNode;
};

const EnrollmentFileProcessingStep = (props: EnrollmentFileProcessingStepProps) => {
  const {stepName, titleClassName, statusIcon, children} = props;
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return isMobile ? (
    <div className="mobile-status-tracker__step">
      <div className="mobile-status-tracker__step--title">
        <span className="icon">{statusIcon}</span>
        <span className={titleClassName}>{stepName}</span>
      </div>
      <div className="mobile-status-tracker__step--status-details">{children}</div>
    </div>
  ) : (
    <div
      className="horizontal-status-tracker__container"
      key={stepName}
      id={`horizontal-status-tracker-container-${stepName}`}
    >
      {statusIcon}
      <span className={`horizontal-status-tracker__container--title ${titleClassName}`}>{stepName}</span>
      <div className="horizontal-status-tracker__container--status-details">{children}</div>
    </div>
  );
};

export default EnrollmentFileProcessingStep;
